import _defineProperty2 from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './FiltersSelected.css';
import React, { useContext, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { addQueryStringMultiple } from '../../Listing/index';
import { stateTofacetsObj } from '../ListingOffersAndDeals';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { ReactComponent as IconClose } from '../../../resources/icons/close-tag.svg';
import { DATE_RANGE_FACET_NAME } from '../ListingOffersAndDeals';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
var commonStyles = "c1pmfytf";
var ltrStyles = "l1xb2ro9";
var rtlStyles = "rx6ktd5";
var FiltersSelected = function FiltersSelected(_ref) {
  var filterState = _ref.filterState,
    setFilter = _ref.setFilter,
    resetFilters = _ref.resetFilters,
    clearText = _ref.clearText,
    setListingFilter = _ref.setListingFilter,
    facets = _ref.facets,
    resetAndSubmitFilters = _ref.resetAndSubmitFilters,
    eventsAnalytics = _ref.eventsAnalytics,
    params = _ref.params;
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var history = useHistory();
  var filtersToDisplay = useMemo(function () {
    return Object.keys(filterState);
  }, [filterState]);
  if (!filtersToDisplay.length) return null;
  var selectedItemsLength = 0;
  filtersToDisplay.forEach(function (item) {
    selectedItemsLength += filterState[item].value.length;
  });
  if (!selectedItemsLength) return null;
  var removeFilterAnalyticsClick = function removeFilterAnalyticsClick(text) {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['removeFilterAnalytics'], params), text);
  };
  var clearAllHandler = function clearAllHandler() {
    resetAndSubmitFilters();
    var newState = _objectSpread({}, filterState);
    var finalQSObject = stateTofacetsObj(newState);
    var url = new URL(window.location.href);
    Object.keys(finalQSObject).forEach(function (facet) {
      if (finalQSObject[facet] && facet !== DATE_RANGE_FACET_NAME) {
        url.searchParams.delete(facet);
      }
    });
    history.replace("".concat(history.location.pathname).concat(url.search).concat(url.hash));
    resetFilters(newState);
    setListingFilter();
    removeFilterAnalyticsClick(clearText);
  };
  return /*#__PURE__*/React.createElement("ul", {
    className: "filters__selected ".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, filtersToDisplay.map(function (filterFieldTitle, index) {
    if (filterState[filterFieldTitle].facetName === DATE_RANGE_FACET_NAME) {
      if (filterState[filterFieldTitle].valueReadableString) {
        return /*#__PURE__*/React.createElement("li", {
          key: index,
          className: "filters__selected-item"
        }, filterState[filterFieldTitle].valueReadableString, /*#__PURE__*/React.createElement("button", {
          className: "filters__selected-remove-btn",
          onClick: function onClick() {
            //set empty value => OfferAndDealDatePicker tracks value and clear it of its empty
            setFilter(_defineProperty2({}, filterFieldTitle, _objectSpread(_objectSpread({}, filterState[filterFieldTitle]), {}, {
              value: '',
              valueReadableString: ''
            })));
          }
        }, /*#__PURE__*/React.createElement(IconClose, null)));
      }
    } else {
      return filterState[filterFieldTitle].value.filter(function (tagName) {
        return facets[filterState[filterFieldTitle].facetName] && facets[filterState[filterFieldTitle].facetName][tagName];
      }).map(function (tagName) {
        return /*#__PURE__*/React.createElement("li", {
          className: "filters__selected-item",
          key: tagName
        }, tagName, /*#__PURE__*/React.createElement("button", {
          className: "filters__selected-remove-btn",
          onClick: function onClick() {
            var newValues = filterState[filterFieldTitle].value.filter(function (item) {
              return item !== tagName;
            });
            var selected = _defineProperty2({}, tagName, false);
            setFilter(_defineProperty2({}, filterFieldTitle, _objectSpread(_objectSpread({}, filterState[filterFieldTitle]), {}, {
              value: newValues
            })));
            removeFilterAnalyticsClick(tagName);
            addQueryStringMultiple(filterState[filterFieldTitle].facetName, selected, history);
            setListingFilter();
          }
        }, /*#__PURE__*/React.createElement(IconClose, null)));
      });
    }
  }), /*#__PURE__*/React.createElement("li", {
    className: "filters__selected-item-clear"
  }, /*#__PURE__*/React.createElement("button", {
    className: "filters__selected-clear-btn",
    onClick: clearAllHandler
  }, clearText)));
};
export default FiltersSelected;